import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import axios from 'axios';
import { has, isString } from 'lodash';
import toast from 'react-hot-toast';
// get request error msg, this is temporary because the existing systems is no uniform
export var handleRequestError = function handleRequestError(err, data) {
  var _response$data, _response$data$conten, _response$data2, _response$data2$detai, _response$data2$detai2, _response$data3, _response$data3$detai, _response$data4, _response$data5, _response$data6;

  if (!err) return [null, err];
  var response = err.response || {};
  var message = '';
  var serverMessage = ''; // add status

  message += "".concat(response === null || response === void 0 ? void 0 : response.status, "\uFF1A"); // possibility 1

  var msg1 = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$conten = _response$data.content) === null || _response$data$conten === void 0 ? void 0 : _response$data$conten.params; // possibility 2

  var msg2 = response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$detai = _response$data2.detail) === null || _response$data2$detai === void 0 ? void 0 : (_response$data2$detai2 = _response$data2$detai[0]) === null || _response$data2$detai2 === void 0 ? void 0 : _response$data2$detai2.msg; // possibility 3

  var msg3 = response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : (_response$data3$detai = _response$data3.detail) === null || _response$data3$detai === void 0 ? void 0 : _response$data3$detai.description; // possibility 4

  var msg4 = response !== null && response !== void 0 && (_response$data4 = response.data) !== null && _response$data4 !== void 0 && _response$data4.detail && isString(response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.detail) ? response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.detail : '';

  if (msg1) {
    serverMessage += msg1;
  } else if (msg2) {
    serverMessage += msg2;
  } else if (msg3) {
    serverMessage += msg3;
  } else if (msg4) {
    serverMessage += msg4;
  }

  err.message = message + serverMessage;
  err.serverMessage = serverMessage;

  if (!(data !== null && data !== void 0 && data.hideErrToast) && message && !axios.isCancel(err) && !((data === null || data === void 0 ? void 0 : data.hideToastStatusCodes) || []).includes(response.status)) {
    toast.error(err.message, {
      duration: 2500
    });
  }

  return [null, err];
};
export var filterOutRequestExtraParameters = function filterOutRequestExtraParameters(payload) {
  var newPayload = _objectSpread({}, payload);

  if (has(newPayload, 'hideErrToast')) {
    delete newPayload.hideErrToast;
  }

  if (has(newPayload, 'apiSource')) {
    delete newPayload.apiSource;
  }

  return newPayload;
};
export var handleApiRequestSuccessData = function handleApiRequestSuccessData(requestRes) {
  var data = requestRes === null || requestRes === void 0 ? void 0 : requestRes.data;

  if (data) {
    if (has(data, 'code') && has(data, 'data') && has(data, 'message')) {
      if (data.code !== 0) {
        toast === null || toast === void 0 ? void 0 : toast.error(data.message || 'Interface request failed!');
      }
    }
  }
};